module.exports = __webpack_public_path__ + "static/media/merchandising.0fba6832.svg";